function formatPrice(amount: number, currencyCode: string){
    if (!currencyCode){
        currencyCode = 'usd'
    }else{
        currencyCode = currencyCode.toLowerCase()
    }
    let currencySymbol = '';
    if (currencyCode === 'usd'){
        currencySymbol = "$"
    }else if (currencySymbol === 'eur'){
        currencySymbol = "€"
    }else if (currencySymbol === 'gbp'){
        currencySymbol = "£"
    }

    return `${currencySymbol}${amount}`.trim()
}

function openWindow(url: string, target: string) {
    const width = 1024;
    const height = 720;
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 4;
    const newWindow = window.open(
        url,
        target,
        'width=' + width + ',height=' + height + ', top=' + top + ', left=' + left
    );
    if (newWindow) {
        newWindow.focus()
    }
}

function formatDuration(interval: number): string {
    const hours = String(Math.floor((interval % 86400) / 3600)).padStart(2, '0');
    const minutes = String(Math.floor(((interval % 86400) % 3600) / 60)).padStart(2, '0');
    const seconds = String(Math.floor(((interval % 86400) % 3600) % 60)).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
}

export {formatPrice, openWindow, formatDuration}
